var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandartsListItems',{attrs:{"routeName":"StandartsClinRec","items":_vm.stdsCatalogGroup,"caption":_vm.caption,"loading":_vm.loading,"error":_vm.error,"paramName":"gid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }